import { useQueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useFieldArray } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { MY_LISTINGS_KEY } from '@steelbuy/data-access';
import {
    ButtonGhostSystemOnLightM,
    ButtonPrimary,
    FormActionbar,
    MarketingBannerContact,
    NotificationIllustrated,
    NotificationIllustratedAlignment,
    NotificationIllustratedItem,
} from '@steelbuy/ui-primitive';
import { RoutePath } from '../../../router/Routes';
import { FormLayout } from '../../../views/layouts/form-layout/FormLayout';
import { scrollMainLayout } from '../../app-layout/app-main-layout/AppMainLayout';
import { PageHeader } from '../../page-header/PageHeader';
import './BulkListingSuccess.scss';
import { getStepRoute } from '../bulkListingUtil';

export const BulkListingSuccess = () => {
    const { t } = useTranslation('translation');
    const navigate = useNavigate();
    const queryClient = useQueryClient();

    const { fields } = useFieldArray({
        name: 'listings',
    });

    const handleCreateListing = () => {
        navigate(RoutePath.CREATE_LISTING_PORTAL);
    };

    useEffect(() => {
        scrollMainLayout(0, 0);
        if (fields.length === 0) {
            navigate(getStepRoute(1), { replace: true });
        }
        queryClient.removeQueries({ queryKey: [MY_LISTINGS_KEY] });
    }, []);

    if (fields.length === 0) {
        return null;
    }

    return (
        <>
            <PageHeader pageTitle={t('application.createBulkListing.header')} />
            <div className="bulk-listing-success">
                <FormLayout>
                    <NotificationIllustrated
                        alignment={NotificationIllustratedAlignment.VERTICAL}
                        imgSrc="/assets/lib-ui-primitive/images/ListingReview-Success.svg"
                        header={t('application.createBulkListingSuccess.notificationMessage')}
                        helperText=""
                    >
                        <NotificationIllustratedItem text={t('application.createListingSuccess.nextStepsHint')} />
                        <NotificationIllustratedItem
                            text={t('application.createBulkListingSuccess.nextStepReview')}
                            isChecked
                        />
                        <NotificationIllustratedItem
                            text={t('application.createListingSuccess.nextStepNotification')}
                            isChecked
                        />
                    </NotificationIllustrated>
                    <MarketingBannerContact
                        header={t('application.createBulkListingSuccess.marketingBannerHeader')}
                        text={t('application.createListingSuccess.marketingBannerText')}
                    >
                        <a href="mailto:support@steel-buy.com">
                            {t('application.createListingSuccess.marketingBannerEmail')}
                        </a>
                    </MarketingBannerContact>
                    <FormActionbar>
                        <ButtonGhostSystemOnLightM
                            label={t('application.createListingSuccess.buttonLabelMyListings')}
                            onClick={() => {
                                navigate(RoutePath.MY_LISTINGS);
                            }}
                        />
                        <ButtonPrimary
                            label={t('application.createBulkListingSuccess.buttonLabelCreateNew')}
                            onClick={handleCreateListing}
                        />
                    </FormActionbar>
                </FormLayout>
            </div>
        </>
    );
};
